module.exports = __webpack_public_path__ + "static/img/en.fcfef678.svg";